import {
  FormControl,
  InputLabel,
  Select as MSelect,
  SxProps,
  Theme
} from '@mui/material'

type Props = {
  testId?: string
  label?: string
  value: string
  disabled?: boolean
  options: string[]
  optionLabels?: string[]
  fullWidth?: boolean
  sx?: SxProps<Theme>
  selectSx?: SxProps<Theme>
  inputLabelSx?: SxProps<Theme>
  onChange: (value: string) => void
}

const Select = ({
  testId,
  label = 'Select',
  value,
  disabled = false,
  options,
  optionLabels,
  fullWidth = false,
  sx,
  selectSx,
  inputLabelSx,
  onChange
}: Props) => {
  return (
    <FormControl fullWidth={fullWidth} sx={sx}>
      <InputLabel
        id="select-label"
        sx={{ left: '-11px', top: '-4px', ...inputLabelSx }}
      >
        {label}
      </InputLabel>
      <MSelect
        native
        inputProps={{ 'data-testid': testId }}
        labelId="select-label"
        value={value}
        disabled={disabled}
        sx={selectSx}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option, index) => (
          <option
            key={option}
            value={option}
            role="option"
            data-testid={option}
          >
            {optionLabels ? optionLabels[index] : option}
          </option>
        ))}
      </MSelect>
    </FormControl>
  )
}

export default Select
